import { useTranslation } from "react-i18next";
import Modal from "../Modal";
import { CreatableSelect } from "chakra-react-select";
import { FormControl, FormLabel, Input } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {getAxiosInstance } from "../../utils/axiosInstance";
import axios from "axios";
import getRolesArray, { role } from "../../utils/rolesTypes";
import { getRandomColor } from "../../utils/getRandomColor";

interface NewUserModalProps {
  isOpen: boolean;
  onClose: () => void;
}

type User = {
  userName: string,
  displayName: string,
  email: string
}

const ModalUsers = (props: NewUserModalProps) => {
  const { t,} = useTranslation("translations");
  const [roles, setRoles] = useState<any>([]);
  const [user, setUser] = useState<User>({ userName: " ", displayName: " ", email: " " });
  const [roleType, setRoleType] = useState<role[]>([]);
  const [placesOfBusiness, setPlacesOfBusiness] = useState<{value: string, label: string, colorScheme: string }[]>([]);
  const [selectedPlacesOfBusiness, setSelectedPalacesOfBusiness] = useState<string[]>([]);

  const setUpUserObject = (value: string, name: string) => {
    setUser({ ...user, [name]: value })
  }

  const setupRolesArray = (r: any) => {
    const list = r.map((x: any) => ({ name: x.value}));
    setRoles([...list]);
  }
  
  const getPlacesOfBusiness = async () => {
    try {
      const res = await getAxiosInstance().get('/Companies/places-of-business');
      const tmp = [];
      for(const t of res.data) {
        tmp.push({
          value: t.id,
          label: `${t.name} (${t.companyName})`,
          colorScheme: getRandomColor()
        })
      }
      setPlacesOfBusiness(tmp);
    } catch (e) {
      toast.error(t(`PLACE_OF_BUSINESS_FETCH_ERROR`), { position: toast.POSITION.BOTTOM_RIGHT });
    }
  }
  
  const addUser = async () => {
    try {
      await getAxiosInstance().post('/users', { ...user, roles: roles, palcesOfBusiness: selectedPlacesOfBusiness });
      toast.success(t("ADDED_USER_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
      props.onClose();
    } catch (error) {
      toast.error("FIELDS_NOT_FILLED_OUT_PROPERLY!", { position: toast.POSITION.BOTTOM_RIGHT });
    }
  }

  useEffect(() => {
    (async () => {
      const rolest = await getRolesArray();
      setRoleType(rolest);
    })();
    getPlacesOfBusiness();
  }, [])

  return (
    <Modal
      header={t("Add User")}
      isOpen={props.isOpen}
      onClose={props.onClose}
      secondaryActionName={t("Save")}
      secondaryActionEnabled={true}
      secondaryAction={() => addUser()}
    >
      <FormControl>
        <FormLabel>
          {t("Username")}
        </FormLabel>
        <Input
          isRequired
          name='userName'
          placeholder={t("Username")}
          onChange={(e) => setUpUserObject(e.target.value, e.target.name)}
        />
      </FormControl>
      <FormControl>
        <FormLabel> {t("Email")} </FormLabel>
        <Input
          isRequired
          placeholder={t("Email")}
          name='email'
          type="email"
          onChange={(e) => setUpUserObject(e.target.value, e.target.name)}
        />
      </FormControl>
      <FormControl>
        <FormLabel> {t("Display Name")} </FormLabel>
        <Input
          isRequired
          placeholder={t("Display Name")}
          name='displayName'
          onChange={(e) => setUpUserObject(e.target.value, e.target.name)}
        />
      </FormControl>
      <FormControl>
        <FormLabel> {t("Roles")} </FormLabel>
        <CreatableSelect
          isRequired
          name={t("types")}
          options={roleType}
          placeholder={t("SELECT_USER_ROLES")}
          onChange={(e) => setupRolesArray(e)}
          isMulti
        />
      </FormControl>
      <FormControl>
        <FormLabel> {t("PlacesOfBusiness")} </FormLabel>
        <CreatableSelect
            name={t("PlacesOfBusiness")}
            options={placesOfBusiness}
            placeholder={t("SELECT_USER_PLACE_OF_BUSINESS")}
            onChange={(e) => setSelectedPalacesOfBusiness(e.map(x => x.value))}
            isMulti
        />
      </FormControl>
    </Modal>
  )
}


export default ModalUsers;